import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, state } = useLocation();

  useEffect(() => {
    // Don't scroll to top if this is tutorial navigation
    if (state?.fromTutorial || sessionStorage.getItem('tutorialNavigation')) {
      return;
    }
    
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [pathname, state]);

  return null;
};

export default ScrollToTop; 